import { useState } from 'react';
import { ImageOff } from 'lucide-react';
import { resolveImageUrl } from '@ai-tiaozs/shared';

/**
 * 通用图片组件
 * - 支持 imageUrl(完整) / imageKey(R2 key) 两种入参
 * - imageUrl 缺省时用 resolveImageUrl 拼代理 URL
 * - 加载失败/缺图 → 显示灰底占位
 * - 适合小卡片缩略图(容器由父级控制)
 */
export function SafeImage({
  team,
  imageUrl,
  imageKey,
  alt,
  className = 'h-16 w-16 rounded-md object-cover ring-1 ring-slate-200',
  placeholderClassName = 'flex h-16 w-16 items-center justify-center rounded-md bg-slate-100 text-slate-400',
}: {
  team: 'a' | 'b';
  imageUrl?: string | null;
  imageKey?: string | null;
  alt: string;
  className?: string;
  placeholderClassName?: string;
}) {
  const [errored, setErrored] = useState(false);
  const url = resolveImageUrl({ imageUrl, imageKey, team });
  if (!url || errored) {
    return (
      <div className={placeholderClassName} aria-label="暂无照片">
        <ImageOff className="h-4 w-4" />
      </div>
    );
  }
  return <img src={url} alt={alt} className={className} onError={() => setErrored(true)} />;
}
